export default __webpack_public_path__ + "static/media/personaje -Banner-Inscripción.564260ba.png";